<template>

<div>
    <link href="static/bootstrap.min.css" rel="stylesheet">
    <div class="login-wrap">

        <div class="row">
            <div class="col-md-6" :style="(webW?'':'text-align: center')">
                <router-link to="Forum">
                    <img src="../assets/img/logow.png" :class="webW?'logow':'logow_phone'">
                </router-link>
            </div>
            <div class="col-md-6">
                <div  :class=" (webW2?'ms-login':'phonedivp') ">

                    <el-card class="box-card">
                        <div slot="header"  :class=" (webW?'':'center') ">
                            <span style="color:#f40;">找回密码</span> /
                            <router-link to="Login" style="color: #888888;">登录</router-link>
                        </div>
                        <div>
                            <el-form :model="dataForm" :rules="adminRules" ref="dataForm" label-width="0px" :class="(webW2?'ms-content':'ms-content_phone')">
                                <el-form-item prop="email">
                                    <el-input placeholder="请输入注册邮箱" v-model="dataForm.email" class="input-with-select">
                                        <template style="width: 90px;" slot="prepend">
                                            &nbsp;&nbsp;注册邮箱&nbsp;&nbsp;
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <el-input placeholder="请输入验证码" type="number" v-model="dataForm.code">
                                        <template slot="prepend">图形验证码</template>
                                        <template slot="append">
                                            <img v-if="codeimg!=''" @click="getImgCodeFunc" style="height: 33px;float: left;"
                                                 :src="codeimg">
                                            <span v-else @click="getImgCodeFunc" style="width: 90px;">获取验证码</span>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="ecode">
                                    <el-input placeholder="请输入验证码" type="number" v-model="dataForm.ecode">
                                        <template slot="prepend">邮件验证码</template>
                                        <template slot="append">
                                            <el-button style="width:125px;" @click="sendCode" :disabled="ts==60?false:true">
                                                {{tsmsg}}
                                            </el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="upass">
                                    <el-input type="password" placeholder="请输入新密码" v-model="dataForm.upass"
                                              @keyup.enter="submitForm()" show-password>
                                        <template #prepend>
                                            &nbsp;&nbsp;&nbsp;&nbsp;新密码&nbsp;&nbsp;&nbsp;
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="upass2">
                                    <el-input type="password" placeholder="请输入确认密码" v-model="dataForm.upass2"
                                              @keyup.enter="submitForm()" show-password>
                                        <template #prepend>
                                            &nbsp;&nbsp;确认密码&nbsp;&nbsp;
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <div class="login-btn">
                                    <el-button type="primary" @click="submitForm()">确定修改</el-button>
                                </div>

                            </el-form>
                        </div>
                    </el-card>


                </div>

            </div>
        </div>




<!--        <Lianjie/>-->
    </div>
</div>


</template>

<script>
    import Lianjie from "./Lianjie.vue";

    import { getImgCode, emailIsVaild, sendEmailCodeForFindUpass,updateUpassByEmail} from '../api/index';
    import {dealResult, emailReg, getSessionid, getWindowWidth, isWeb, lianjie} from '../api/common';
    import {validateEmail, validateUpass} from "../api/validator";


    export default {
        name: "FindUpassByEmail",
        components: {
            Lianjie
        },

        data() {
            const checkVaildEmail = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    emailIsVaild({email: str}).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };

            const confirmPassword = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("请输入确认密码");
                } else if (str !== this.dataForm.upass) {
                    callback('两次输入密码不一致!');
                } else {
                    callback();
                }
            };

            return {
                webW:true,
                webW2:true,

                ts: 60,
                tsmsg: '点击发送',

                codeimg: '',
                sessionid: '',

                dataForm: {
                    email: "",
                    code: '',
                    ecode: '',
                    upass: "",
                    upass2: "",

                },

                adminRules: {
                    upass: [{required: true, message: "请输入密码", trigger: "blur"},
                        {validator: validateUpass, trigger: "blur"},],
                    upass2: [{required: true, message: "请输入确认密码", trigger: "blur"},
                        {validator: confirmPassword, trigger: "blur"},],
                    email: [{required: true, message: "请输入邮箱", trigger: "blur"},
                        {validator: validateEmail, trigger: "blur"},
                        {validator: checkVaildEmail, trigger: "blur"},],
                    code: [{required: true, message: "请输入图形验证码", trigger: "blur"}],
                    ecode: [{required: true, message: "请输入邮箱验证码", trigger: "blur"}],

                },


            }
        },
        methods: {
            getImgCodeFunc() {
                getImgCode({sessionid: this.sessionid}).then((res) => {
                    if (res.data.status == 1) {
                        this.codeimg = res.data.obj;
                    } else {
                        this.codeimg = '';
                        this.$message.error(res.data.msg)
                    }
                })
            },
            gotoA(a) {
                window.open(lianjie[a], '_blank')
            },
            sendCode() {


                if ((!emailReg.test(this.dataForm.email))) {
                    this.$message.info('邮箱格式错误');return;
                }
                if(this.dataForm.code.trim().length==0){
                    this.$message.info('请输入图形验证码');return;
                }
                sendEmailCodeForFindUpass({
                    email: this.dataForm.email,
                    sessionid: this.sessionid,
                    code: this.dataForm.code
                }).then((res) => {

                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg)

                        let seti = setInterval(() => {
                            this.ts = this.ts - 1;
                            this.tsmsg = "还剩" + this.ts + "秒";
                            if (this.ts <= 0) {
                                clearInterval(seti);
                                this.ts = 60;
                                this.tsmsg = "点击发送";
                            }
                        }, 1000)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })


            },
            submitForm() {

                this.$refs.dataForm.validate(valid => {

                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message("请按提示填写表单");
                        return false;
                    } else {
                        this.dataForm.sessionid = this.sessionid;
                        this.loading = this.$loading({
                            lock: true,
                            text: "请求中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        updateUpassByEmail(this.dataForm).then((res) => {
                            this.loading.close();

                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg);
                                this.$router.replace("Login");

                                localStorage.email=this.dataForm.email;
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(() => {
                            this.loading.close();
                            this.$message.info('请求失败，请检查网络');
                        });

                    }
                })
            }


        }, mounted() {
            this.webW = getWindowWidth() >= 992 ? true : false;
            this.webW2 = getWindowWidth() >= 500 ? true : false;

            if (this.$store.state.sessionid.trim().length == 0) {
                this.$store.dispatch('saveSessionid', getSessionid());
            }
            this.sessionid = this.$store.state.sessionid;


            this.getImgCodeFunc();


            if (localStorage.email != undefined) {

                this.dataForm.email = localStorage.email;
            }


        }
    };
</script>

<style scoped>
    .phonedivp{width: 100%;margin-left: 0;margin-top: 20px;}


    .login-wrap {
        position: relative;
        width: 100%;
        min-height: 100vh;
        background-image: url(../assets/img/loginback.jpg);
        background-size: 100% 100%;
        overflow-x: hidden;
    }

    .ms-login {
        margin-top: 40px;
        width: 500px;
        margin-left: calc( 50% - 250px);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .ms-content {
        padding: 30px 30px;
    }
    .ms-content_phone {
        padding:  0px  0px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }





    /deep/ .el-input-group__append, .el-input-group__prepend{
        padding:0px 0px;
    }
    .logow{ margin-top: 40px;;width: 150px; margin-left: 20%;}
    .logow_phone{ margin-top: 10px;;width:100px;  }
</style>
